/*=========================================================================================
  File Name: moduleSpaceGetters.js
  Description: Space Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getMemberInfo: state => (Id) => state.workspaceMembers.find((member) => member.user_id == Id),
  filteredWorkspace: state => state.workspaces.filter((workspace) => {
    if(state.checkboxClassState == 0){
      return (workspace.alone == true)
    }
    if(state.checkboxClassState == 1){
      return (workspace.alone == state.checkboxAloneState && workspace.service == true)
    }
    if(state.checkboxClassState == 2){
      return (workspace.alone == state.checkboxAloneState && workspace.service == false)
    }
    if(state.checkboxClassState == 3){
      return (workspace.alone == false)
    }
  }),
  getServiceWorkspace: state => state.workspaces.filter((workspace) => {
    return (workspace.service == true)
  })
}
